import { formatCount, formatRelative } from '../../lib/format'
import type { Status } from './types'

export function EndpointsTable({ endpoints }: { endpoints: NonNullable<Status['endpoints']> }) {
	const classes = Object.keys(endpoints.breakers).sort()
	return (
		<div className="table-scroll">
			<table>
				<thead>
					<tr>
						<th>Endpoint</th>
						<th className="num">Requests 1h / 24h</th>
						<th className="num">Errors 24h</th>
						<th className="num">Throttled 24h</th>
						<th>State</th>
					</tr>
				</thead>
				<tbody>
					{classes.map((c) => {
						const hour = endpoints.lastHour[c]
						const day = endpoints.last24h[c]
						const paused = endpoints.breakers[c].pausedUntil
						return (
							<tr key={c}>
								<td>{c}</td>
								<td className="num">
									{formatCount(hour?.requests ?? 0)} / {formatCount(day?.requests ?? 0)}
								</td>
								<td className="num" title={day?.lastError}>
									{day?.errors ?? 0}
								</td>
								<td className={`num ${day?.throttles ? 'error' : ''}`}>{day?.throttles ?? 0}</td>
								<td className="small">
									{paused ? (
										<span className="error">paused until {formatRelative(paused)}</span>
									) : (
										<span className="up">ok</span>
									)}
								</td>
							</tr>
						)
					})}
				</tbody>
			</table>
		</div>
	)
}
